import React from "react";
import { useSelector } from "react-redux";

import { Container } from "react-bootstrap";

import folder from "../../../../../image//labReport/folder.png";
import difficultyLow from "../../../../../image//labReport/difficulty-low.png";
import difficultyMedium from "../../../../../image//labReport/difficulty-medium.png";
import difficultyHigh from "../../../../../image//labReport/difficulty-high.png";

import { TitleBox } from "../styledActivityTab";

import { StyledUserInfo, UserHistoryInfo } from "./styledActivityInfo";

const ActivityInformationComponent = ({ simReportData }) => {
  const userDetail = useSelector((state) => state.userDetail);

  const historySideData = [
    { id: 1, title: "تاریخچه تمرین", data: simReportData?.exercise_report },
    { id: 2, title: "تاریخچه آزمون", data: simReportData?.quiz_report },
  ];

  const difficultyQuizeIcon = [
    { id: 1, difficulty: "low", image: difficultyLow },
    { id: 2, difficulty: "medium", image: difficultyMedium },
    { id: 3, difficulty: "high", image: difficultyHigh },
  ];

  return (
    <Container className="d-flex flex-column px-0">
      <StyledUserInfo className="px-3 px-md-4 mb-3 d-flex flex-row align-items-center justify-content-around">
        {userDetail?.userDetail.length !== 0 && (
          <span className="profile-wrapper rounded-circle d-flex align-items-center justify-content-center">
            <img
              src={simReportData?.user.usermeta.img_addr}
              alt="user-profile"
              className="img-fluid"
              height="70px"
              width="70px"
            />
          </span>
        )}
        <span className="user-information">
          <p className="user-name m-0">
            {simReportData?.user.first_name}&nbsp;
            {simReportData?.user.last_name}
          </p>
          <p className="user-nid m-0">{simReportData?.user.usermeta.nid}</p>
          <p className="user-nid m-0">
            <span>{simReportData?.subject[0].name}&nbsp;</span>
            <span>{simReportData?.grade[0].name}&nbsp;</span>
          </p>
        </span>
      </StyledUserInfo>
      {historySideData.map((history) => (
        <UserHistoryInfo
          className="p-2 mb-3 d-flex flex-column align-items-center"
          key={history.id}
        >
          <TitleBox className="text-center pt-2">{history.title}</TitleBox>
          {history?.data?.length !== 0 ? (
            <ul className="w-100 p-0 my-2">
              {history?.data?.map((item, index) => (
                <li
                  key={`li-data-${index}`}
                  className="d-flex flex-row justify-content-around align-items-center"
                >
                  <p className="mx-2 my-0">{index + 1}</p>
                  {difficultyQuizeIcon.map((image) => {
                    if (image.id === item.difficulty) {
                      return (
                        <img
                          src={image.image}
                          alt={image.difficulty}
                          key={item.id}
                        />
                      );
                    }
                  })}
                  <p className="mx-2 my-0">
                    {item.finish_at
                      .split(" ")[0]
                      .replace("-", "/")
                      .replace("-", "/")}
                  </p>
                  <p className="mx-2 my-0">
                    {/*---- MYTODO:percent must be updated to user_score----- */}
                    {/* {item.user_score}/{item.full_score} */}%{item.percent}
                  </p>
                </li>
              ))}
            </ul>
          ) : (
            <img src={folder} alt="folder" />
          )}
        </UserHistoryInfo>
      ))}
    </Container>
  );
};

export default ActivityInformationComponent;
